import React, { Component } from "react";
import PropTypes from "prop-types";
import DebouncedInput from "components/Common/DebouncedInput";
import LoginSplash from "components/Common/LoginSplash";
import "./style.scss";

export class MFAVerificationForm extends Component {
  /**
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.formatPhoneNumber = this.formatPhoneNumber.bind(this);
    this.onWrongNumberClick = this.onWrongNumberClick.bind(this);
    this.renderWrongNumber = this.renderWrongNumber.bind(this);
  }

  /**
   * calls handleWrong number from prop to show phone number form
   */
  onWrongNumberClick() {
    const { handleWrongNumber } = this.props;
    handleWrongNumber();
  }

  /**
   * @param {String} value
   */
  handleInputChange(value) {
    const { handleInputChange } = this.props;
    handleInputChange("verificationCode", value);
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeyPress(event) {
    if (event.keyCode === 13) {
      this.onWrongNumberClick();
    }
  }

  /**
   * @returns {String} phoneNumber
   * if phone number is from north america format as (416) 123-4567
   * otherwise return the phone number
   */
  formatPhoneNumber() {
    const { countryCode, phoneNumber } = this.props;
    const phone = phoneNumber.replace(/[^\d]/g, "");

    if (phone.length === 10 && countryCode.includes("+1")) {
      return `${countryCode} ${phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}`;
    }

    return `${countryCode} ${phoneNumber}`;
  }

  /**
   * @returns {HTMLElement}
   */
  renderWrongNumber() {
    return (
      <span className="MFAVerificationForm__action" role="link" tabIndex="0" onKeyPress={this.handleKeyPress} onClick={this.onWrongNumberClick}>Wrong Number?</span>
    );
  }

  /**
 * @returns {HTMLElement}
 */
  render() {
    const {
      currentStep, onClick, verificationCode, errorMessage, resetNotificationError
    } = this.props;

    if (currentStep !== 3) {
      return null;
    }

    const phoneNumber = this.formatPhoneNumber();
    const description = <span>We set a 7 digit code to <span className="MFAVerificationForm__phone-number"> {phoneNumber}</span> via SMS. {this.renderWrongNumber()}</span>;

    return (
      <LoginSplash
        title="Enter Verification Code"
        button={{
          label: "Submit",
          action: () => onClick()
        }}
        linkText="Wrong Number?"
        onClickAction={this.onWrongNumberClick}
        description={description}
        showError={Boolean(errorMessage)}
        resetNotificationError={resetNotificationError}
        errorMessage={errorMessage}
      >
        <div className="MFAVerificationForm__label">
          <label
            className="g-form__block__label"
            htmlFor="MFAVerificationForm__input"
          >
            7 Digit Code
          </label>
          <DebouncedInput
            name="VerificationCode"
            value={verificationCode}
            type="text"
            placeholder="1234567"
            onChange={this.handleInputChange}
            id="VerificationCode__input"
          />
          <div className="MFAVerificationForm__more-information">
            <p>Your code may take up to 30 seconds to arrive.
              <br />
              Didn&#39;t receive code yet?&nbsp;
              <a href="mailto:help@ada.support" className="MFAVerificationForm__action">
                Get Help
              </a>
            </p>
          </div>
        </div>
      </LoginSplash>
    );
  }
}


MFAVerificationForm.propTypes = {
  countryCode: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleWrongNumber: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  resetNotificationError: PropTypes.func.isRequired,
  verificationCode: PropTypes.string.isRequired
};
